import React from 'react'

export default function RadioInput(props) {
  const {value, label, checked, onClick} = props;
  return (
    <div className='htmlRadioInput'>
      <label>
        <input 
          type="radio" 
          value={value} 
          checked={checked}
          onChange={onClick} 
        />
        {label}
      </label>     
    </div>     
  )
}